module.exports = "/_next/static/images/image-placeholder-e727da9837aa809573a14ff1b4c52eab.png";